/*
Authore: Umer Shabir 
modifiet_Date: 11-10-2022
file: this file about patient and family member medical history record
*/
// dependencies
import { useEffect, useState } from "react";
import axios from "axios";
import AlertMessage from "../../../../../Components/AlertMessage";
import Spinner from "react-bootstrap/Spinner";
import { API_CONSTANTS } from "../../../../../API_CONSTANTS";
import { useSelector } from "react-redux";
import AssignmentSolutionTable from "./AssignmentTable";
// medical history component
export default function Assignments() {
  const [assignments, setAssignments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState("assignment");
  const { value } = useSelector((state) => state.getPatientProfileReducer)
  // dispatching to clear the states.

  const data = {
    patient_id: value.profiles.self.profileId,
    mode: filter
  }
  const getAssignments = () => {
    setIsLoading(true);
    axios
      .get(
        `${API_CONSTANTS.BASEURL_5}admin/get-assignments`,  
        {
          headers: API_CONSTANTS.headers(),
          params: data
        }
      )
      .then((res) => {
        setIsLoading(false);
        setAssignments(
          res.data.response.items
        );
      })
      .catch((error) => {
        setIsLoading(false);
        setAssignments([]);
        //setError(error);
      });
  };
  // filters function

  const is_SessionExpire = () => {
    // window.localStorage.clear();
    // window.location.reload();
  };

  useEffect(() => {
    getAssignments();
  }, [
    filter
  ]);

  if (error) {
    return (
      <AlertMessage
        errorMessage={
          error.message === "Request failed with status code 404"
            ? "This record does not exist"
            : error.message === "Request failed with status code 401"
            ? is_SessionExpire()
            : error.message
        }
      />
    );
  } else if (isLoading) {
    return (
      <div className="d-flex justify-content-center mt-3">
        <Spinner animation="border" style={{ color: "#24AAA4" }} />
      </div>
    );
  } else {
    return (
      <>
        <div className="row rounded bg-white m-4 ">
          <div className="p-0">
            <h3
              style={{ fontSize: "16px", fontWeight: "500", padding: "18px" }}
            >
              All Records
            </h3>
          </div>
          <AssignmentSolutionTable
            data={assignments}
            modeFilter={filter}
            onFilterChange={(filter) => {setFilter(filter)}}
          />
        </div>
      </>
    );
  }
}
